export const SET_LOADING = 'src/store/profile/SET_LOADING'
export const SET_SAVE_PROFILE_LOADING = 'src/store/profile/SET_SAVE_PROFILE_LOADING'
export const SET_SAVE_PASSWORD_LOADING = 'src/store/profile/SET_SAVE_PASSWORD_LOADING'
export const SET_PERMISSION = 'src/store/profile/SET_PERMISSION'
export const SET_PROFILE = 'src/store/profile/SET_PROFILE'
export const SET_PROFILE_RESPONSE = 'src/store/profile/SET_PROFILE_RESPONSE'
